<template>
  <div>
    <section class="no-print" v-if="hideOptions === false">
      <v-row align="center">
        <v-col cols="12" sm="3">
          <j-decimal-input
            dense
            filled
            class="no-before"
            v-model="multiple"
            hide-details
            suffix=""
            label="Multiplicateur de la quantité produite"
          ></j-decimal-input>
        </v-col>
      </v-row>
    </section>
    <v-card flat v-if="recipe">
      <v-card-title>
        <v-row align="center" justify="space-between" no-gutters>
          <span class="headline text-capitalize">{{ recipe.nom }}</span>
          <span class="subtitle-1">
            Quantité produite: {{ convertedRecipeQuantity }}
            {{ recipe.unite_produite }}
          </span>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <span class="subtitle-1" v-if="recipe.data">{{
            recipe.data.tags.join(", ")
          }}</span>
        </v-row>
        <v-divider class="mt-1"></v-divider>
        <v-row no-gutters class="my-1">
          <span class="title">Instructions</span>
        </v-row>
        <v-row no-gutters class="mt-1">
          <v-container>
            <RecipeInstructionsRenderer
              :instructions="recipe.instructions"
            ></RecipeInstructionsRenderer>
          </v-container>
        </v-row>
        <v-divider class="mt-1"></v-divider>
        <v-row no-gutters class="my-1">
          <span class="title">Ingrédients</span>
        </v-row>
        <v-container>
          <IngredientViewerGrid
            :ingredients="recipe.ingredients"
            :multiple="multiple"
            :recipe-quantity="recipe.quantite_produite"
          ></IngredientViewerGrid>
        </v-container>
        <v-divider class="mt-1"></v-divider>
        <v-row
          no-gutters
          class="my-1"
          v-if="getIngredientsAllergens.length > 0"
        >
          <span class="title">Allergènes</span>
        </v-row>
        <v-container>
          <v-row no-gutters>
            <span>{{ getIngredientsAllergens.join(", ") }}</span>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { api } from "@/api";
import {
  RecipeInstructionsRenderer,
  IngredientViewerGrid
} from "../components";
import { mapGetters } from "vuex";
export default {
  name: "RecipeViewer",
  props: {
    id: {
      required: true
    },
    quantity: {
      default: null
    },
    hideOptions: {
      type: Boolean,
      default: false
    },
    mountedMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    RecipeInstructionsRenderer,
    IngredientViewerGrid
  },
  computed: {
    ...mapGetters(["getOrganisationId", "getProducts"]),
    getIngredientsAllergens() {
      return [
        ...new Set(
          this.recipe.ingredients
            .filter(x => x.is_deleted === false)
            .map(x => {
              const product = this.getProducts.find(
                p => p.id === x.pk_recette_produit
              );
              if (product) {
                if (product.data && product.data.allergens.length > 0) {
                  return product.data.allergens;
                } else {
                  return [];
                }
              }
            })
            .flat()
        )
      ].filter(x => x !== undefined);
    },
    convertedRecipeQuantity() {
      return this.recipe.quantite_produite * this.multiple;
    }
  },
  async mounted() {
    if (this.mountedMode === true) {
      await this.getData();
    }
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      vm.prevRoute = from;
      await vm.getData();
    });
  },
  async beforeRouteUpdate(to, from, next) {
    await this.getData();
    next();
  },
  data() {
    return {
      prevRoute: null,
      recipe: undefined,
      multiple: 1
    };
  },
  methods: {
    async getData() {
      try {
        this.$store.dispatch("startLoadingOverlay");
        if (this.quantity !== null) this.multiple = this.quantity;
        if (this.mountedMode === false) {
          await Promise.all([
            this.$store.dispatch("loadProducts", {
              organisation: this.getOrganisationId
            }),
            this.$store.dispatch("loadIngredients", {
              organisation: this.getOrganisationId
            })
          ]);
        }

        this.recipe = await api.retrieveRecipe(this.id);
        if (
          this.recipe.instruction !== undefined &&
          this.recipe.instruction !== null &&
          Object.entries(this.recipe.instructions).length === 0 &&
          this.recipe.instructions.constructor === Object
        ) {
          const lines = this.recipe.instruction.split("\n");
          this.recipe.instructions = {
            time: Date.now(),
            blocks: [
              ...lines.map(x => {
                return {
                  type: "paragraph",
                  data: {
                    text: x
                  }
                };
              })
            ],
            version: "2.15.1"
          };
        }
        this.recipe.ingredients.forEach(x => {
          if (x.unite_mesure === null) {
            const product = this.getProducts.find(
              p => p.id === x.pk_recette_produit
            );
            if (product && product.data) {
              if (product.data.use_conversion_formula) {
                x.unite_mesure = product.data.unite_mesure;
              } else {
                x.unite_mesure = product.data.unite_mesure_inventory;
              }
            }
          }
        });
      } finally {
        this.$store.dispatch("endLoadingOverlay");
      }
    }
  }
};
</script>

<style></style>
